// SPDX-License-Identifier: Elastic-2.0
/**
 * OfflinePage — fallback route rendered when the SW navigateFallback
 * can't reach the SPA shell from cache OR when the user lands at
 * `/offline` directly (rare; mostly a CI/health-check path).
 *
 * Production users typically don't see this — the SW + cached shell
 * keep them on their last route with the offline banner. This page is
 * the worst-case "we have nothing" surface.
 */
import { useTranslation } from "react-i18next";

import { MirlaiMark } from "../components/MirlaiMark/MirlaiMark";
import styles from "./OfflinePage.module.css";

export function OfflinePage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className={styles.root} data-testid="offline-page">
      <MirlaiMark size={96} />
      <h1 className={styles.title}>{t("pwa.offline_page_title")}</h1>
      <p className={styles.body}>{t("pwa.offline_page_body")}</p>
    </main>
  );
}

export default OfflinePage;
